module.exports = __webpack_public_path__ + "static/Logo-a654a3ea14cb583b5a5c5c3cacbe3c9b.png";